import { render, staticRenderFns } from "./AssignmentPlanView.vue?vue&type=template&id=54cf9845&scoped=true&"
import script from "./AssignmentPlanView.vue?vue&type=script&lang=js&"
export * from "./AssignmentPlanView.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentPlanView.vue?vue&type=style&index=0&id=54cf9845&prod&lang=scss&scoped=true&"
import style1 from "./AssignmentPlanView.vue?vue&type=style&index=1&id=54cf9845&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cf9845",
  null
  
)

export default component.exports